<template>
  <el-select
    v-if="isShowSelect"
    v-model="form[field.key]"
    :placeholder="`Chọn ${field.name}`"
    class="w-100"
    filterable
    :multiple="field.type === fieldType.MULTIPLE_SELECT"
    :disabled="disabled"
    :size="size || 'default'"
    clearable
    @change="(v) => (form[field.key] = v)"
  >
    <el-option
      v-for="(option, index) in options"
      :key="index"
      :label="option.label"
      :value="option.value"
    />
  </el-select>
</template>

<script>
import { mapGetters } from "vuex";
import constants from "@/config/constants";
import { categoryPer } from "@/utils/permission";

export default {
  name: "ItemSelect",
  props: {
    size: String,
    form: Object,
    field: Object,
    disabled: Boolean,
    config: Object,
    contractModules: Array
  },
  data() {
    return {
      fieldType: constants.FIELD_TYPE,
      searchText: "",
      searchTimeout: null,
      permission: categoryPer(),
    };
  },
  computed: {
    ...mapGetters("config", ["allConfigs"]),
    ...mapGetters("category", ["allCategories"]),
    isMultiple() {
      return this.field.type === this.fieldType.MULTIPLE_SELECT;
    },
    category() {
      return this.allConfigs.find(
        (c) => c.extra.key === this.field.options.type
      );
    },
    options() {
      if (this.field.type === this.fieldType.MODULE) {
        return (this.contractModules || this.config?.extra?.modules || []).map((m) => ({
          value: m.key,
          label: m.name
        }))
      }
      if (this.field.options.type) {
        const showCategoryField = this.category?.extra?.fields?.find(
          (f) => f.show.display
        );
        return this.allCategories.filter((c) => c.type === this.field.options.type).map((d) => ({
          label: showCategoryField ? d.extra[showCategoryField.key] : d.extra.name,
          value: d.id,
        }));
      }
      return (this.field.options?.value || []).map((o) => ({
        label: o,
        value: o,
      }));
    },
    isShowSelect() {
      return this.permission.READ
    }
  },
  methods: {
    remoteMethod(query) {
      if (!this.searchTimeout) {
        this.searchTimeout = setTimeout(() => {
          this.searchText = query;
          const filters = this.params.filters;
          delete filters.id;
          this.fetchOptionData({
            ...this.params,
            filters,
          });
        }, 300);
      } else {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = null;
      }
    },
  },
};
</script>

<style lang="scss"></style>
